import { useContextState } from "../../../../../../hooks/theme"

const useStyles = ({active, isMultiple}:{active:boolean, isMultiple:boolean|undefined}) => {
    
    const { colors } = useContextState()
    return {
        actions: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            height: '100%',
            '& .MuiTypography-root': {
                flex: 1
            },
            ...active && ({
                backgroundColor: 'c_green.main',
                '& .MuiTypography-root, .MuiButton-root, span': {
                    color: 'white',
                },
            }),
            ...isMultiple && ({
                border: `1px solid ${colors.color4}`,
            })
        },
        item: {
            flex: 1,/* 
            fontSize: '20px',
            fontWieght: '500', */
            display: 'flex',
            justifyContent: 'center',
            '& .download': {
                padding: '0'
            }
        },
        active:({ active }: { active: boolean | undefined}) => ({
            ...active && ({
                '&.MuiButton-text':{
                    color: 'white'
                }
            })
        }),
        disable: ({ disable }: { disable: boolean}) => ({
            '& .MuiSvgIcon-root':{
                ...disable && ({
                    color:'grey'
                })
            }
        }),
        bigText:{
            fontSize: '20px',
            fontWieght: '500', 
        },
        bigTextAndIcon:({ active }: { active: boolean | undefined}) => ({
            '&.MuiButtonBase-root':{
                    fontSize: '20px',
                    fontWieght: '500',
                },
            ...active && ({
                '&.MuiButtonBase-root':{
                    fontSize: '20px',
                    fontWieght: '500',
                    color: 'white'
                },
            })
        }),
    }
}

export { useStyles }